import { useHistory } from "react-router-dom";
import VehicleTypesControllers from "../../components/General/VehiclesControllers";
import InputField from "../../components/UI/Inputs/InputField";
import InputFile from "../../components/UI/Inputs/InputFile";
import InputSelect from "../../components/UI/Inputs/InputSelect";
import { dataStateType } from "./utils";
import style from "./index.module.css";
import { Control, Controller, FormState, UseFormRegister, UseFormSetError } from "react-hook-form";
import BigNumberInput from "../../components/UI/Inputs/BigNumberInput";
import { useTranslation } from "../../hooks/useTranslation";
import { log } from "console";
import { isSyntheticExpression } from "typescript";
import { VehicleTypesT } from "../../utils/GeneralTypes";

export default function VehicleInfo({
  componentData,
  register,
  control,
  setValue,
  watchedInputs,
  vehicleType: choosedVehicle,
  defaultImages,
  deletedImages,
  setImages,
  formState,
  isEditing,
  setError,
}: ComponentPropsType) {
  const { locale } = useTranslation();
  let history = useHistory();

  return (
    <>
      {!isEditing && (
        <div className={style.page_section}>
          <h4 className={style.page_section__title}>{locale("vehicle_type")}</h4>
          <VehicleTypesControllers
            active={choosedVehicle}
            baseLink=""
            isBtn={true}
            onClickHandler={(vehicleType: VehicleTypesT) =>
              history.push({
                pathname: `/sell-vehicle/${vehicleType}`,
              })
            }
          />
        </div>
      )}
      <div className={style.page_section}>
        <h4 className={style.page_section__title}>{locale("add_images")}</h4>
        <Controller
          control={control}
          name="images"
          rules={{
            validate: (value: unknown[] | undefined) => {
              if (value && value.length > 10) {
                return locale("max10Images");
              }
              return true;
            },
          }}
          render={({ field: { onChange, onBlur, value, ref } }) => {
            return (
              <>
                <InputFile
                  label={locale("add_images")}
                  accept="image"
                  onAddToDeletedFiles={(id: number) =>
                    setImages((current: any) => ({
                      ...current,
                      deleted: [...current.deleted, id.toString()],
                    }))
                  }
                  value={value}
                  onChange={(files) => {
                    onChange(files);
                  }}
                  extraProps={{ multiple: true }}
                  disabled={value.length >= 10}
                  error={formState?.errors?.images?.message as string | undefined}
                  maximumFileCount={10}
                  maximumFileSize={11e6}
                  setFieldError={setError}
                  name="images"
                />
                {value && value.length === 10 ? (
                  <p className={style.page_section__note}>{locale("max10Images")}</p>
                ) : null}
              </>
            );
          }}
        />
        <p className={style.page_section__note}>{locale("add_images_note")}</p>
      </div>
      <div className={style.page_section}>
        <div className={`row ${style.page_row}`}>
          <div className="col-sm-6">
            <InputSelect
              props={{
                ...register("category_0", {
                  validate: (val) => val !== "no_option" || locale("required_field"),
                }),
                value: watchedInputs.category_0,
              }}
              isRequired={true}
              selectOptions={componentData.categories_0}
              label={locale("truck_classification")}
              watchedInputs={watchedInputs}
              setValue={setValue}
              dependantConditions={componentData.categories_0Dependants}
              error={formState?.errors?.category_0?.message}
            />
          </div>
          {/* <div className="col-sm-6">
                <InputSelect
                  props={{
                    ...register("category_1", {
                      validate: (val) => val !== "no_option" || locale("required_field"),
                    }),
                    value: watchedInputs.category_1,
                  }}
                  isRequired={true}
                  selectOptions={componentData.categories_1}
                  label={locale("truck_category")}
                  watchedInputs={watchedInputs}
                  setValue={setValue}
                  dependantConditions={componentData.categories_1Dependants}
                  error={formState?.errors?.category_0?.message}
                />
              </div> */}
          {componentData.categories.filter((el) => (el.dependsOn as any[])?.[0]?.value === watchedInputs.category_1)
            .length > 0 && (
            <div className="col-sm-6">
              <InputSelect
                props={{
                  ...register("category"),
                  value: watchedInputs.category,
                }}
                selectOptions={componentData.categories}
                label={locale("truck_type")}
                watchedInputs={watchedInputs}
              />
            </div>
          )}
          <div className="col-sm-6">
            <InputSelect
              props={{
                ...register("brand", {
                  validate: (val) => val !== "no_option" || locale("required_field"),
                  required: true,
                }),
                value: watchedInputs.brand,
              }}
              isRequired={true}
              selectOptions={componentData.brands}
              label={locale("brand")}
              setValue={setValue}
              watchedInputs={watchedInputs}
              dependantConditions={componentData.brandsDependants}
              error={formState?.errors?.brand?.message}
            />
          </div>
          <div className="col-sm-6">
            <InputSelect
              props={{
                ...register("brand_model", {
                  validate: (val) => {
                    return val !== "no_option" || locale("required_field");
                  },
                  required: true,
                }),
                value: watchedInputs.brand_model,
              }}
              isRequired={true}
              selectOptions={componentData.models}
              label={locale("model")}
              watchedInputs={watchedInputs}
              dependantConditions={componentData.modelsDependants}
              error={formState?.errors?.brand_model?.message}
              setValue={setValue}
            />
          </div>
          <div className="col-sm-6">
            <InputSelect
              props={{
                ...register("model_id", {
                  validate: (val) => {
                    return (val !== undefined && val !== "no_option") || locale("required_field");
                  },
                  required: true,
                }),
                value: watchedInputs.model_id,
              }}
              isRequired={true}
              selectOptions={componentData.modelYears}
              label={locale("year")}
              watchedInputs={watchedInputs}
              error={formState?.errors?.model_id?.message}
            />
          </div>
          {/* {
            // please note that mileage is an attribute, but we were considering mileage as special case that's why we had mileage hard coded in the first step with every type
            // but that's not the case with trucks, not all trucks support mileage
            // so we will just not render it here and let the second step handle it
            choosedVehicle === "truck" ? null : (
              <div className="col-sm-6">
                <Controller
                  control={control}
                  name="milage"
                  rules={{
                    required: locale("required_field"),
                    min: 0,
                    max: 9999999.99,
                  }}
                  render={({
                    field: { onChange, onBlur, value, name, ref },
                    fieldState: { invalid, isTouched, isDirty, error },
                    formState,
                  }) => (
                    <BigNumberInput
                      ref={ref}
                      name={name}
                      id="milage"
                      key="milage"
                      value={value}
                      onValueChange={(v) => {
                        // to enforce max string length
                        if (v && v?.length > 7) return;
                        onChange(v ? +v : "");
                      }}
                      onBlur={onBlur}
                      label={locale("mileage")}
                      placeholder={`20000 ${locale("km")}`}
                      error={formState?.errors?.milage?.message}
                      isRequired={true}
                    />
                  )}
                />
              </div>
            )
          } */}
          <div className="col-sm-6">
            <InputSelect
              props={{
                ...register("city", {
                  validate: (val) => val !== "no_option" || locale("required_field"),
                }),
                value: watchedInputs.city,
              }}
              isRequired={true}
              selectOptions={componentData.cities}
              label={locale("city")}
              setValue={setValue}
              watchedInputs={watchedInputs}
              dependantConditions={componentData.citiesDependants}
              error={formState?.errors?.city?.message}
            />
          </div>
          <div className="col-sm-6">
            <InputSelect
              props={{
                ...register("region_id", {
                  validate: (val) => val !== "no_option" || locale("required_field"),
                }),
                value: watchedInputs.region_id,
              }}
              isRequired={true}
              selectOptions={componentData.regions}
              label={locale("region")}
              watchedInputs={watchedInputs}
              error={formState?.errors?.region_id?.message}
            />
          </div>
          <div className="col-sm-6">
            <Controller
              control={control}
              name="price"
              rules={{
                required: locale("required_field"),
                min: {
                  value: 10000,
                  message: `${locale("min_amount")} = 10000`,
                },
                max: {
                  value: 999_999_999,
                  message: `${locale("max_amount")} = 999,999,999`,
                },
              }}
              render={({
                field: { onChange, onBlur, value, name, ref },
                fieldState: { invalid, isTouched, isDirty, error },
                formState,
              }) => (
                <BigNumberInput
                  ref={ref}
                  name={name}
                  id="price"
                  key="price"
                  value={value}
                  onValueChange={(v) => {
                    if (v && v.length > 9) return;
                    onChange(v ? +v : 0);
                  }}
                  onBlur={onBlur}
                  label={locale("price")}
                  placeholder={`100000 ${locale("egp")}`}
                  error={formState?.errors?.price?.message}
                  isRequired={true}
                />
              )}
            />
          </div>
          {/* {(choosedVehicle === "bus" || choosedVehicle === "truck") && (
            <>
              <div className="col-sm-6">
                <div style={{ paddingTop: "30px" }}>
                  <InputField
                    type="checkbox"
                    extraProps={register("rentable")}
                    label={locale("rentable")}
                    isSwitch={true}
                  />
                </div>
              </div>
              {watchedInputs.rentable && (
                <div className="col-sm-6">
                  <InputField
                    type="number"
                    extraProps={register("rent", {
                      required: locale("required_field"),
                    })}
                    isRequired={true}
                    label={locale("rent")}
                    placeholder={`1000 ${locale("egp")}`}
                    error={formState?.errors?.rent?.message}
                  />
                </div>
              )}
            </>
          )} */}
          <div className="col-12">
            <InputField
              type="textarea"
              extraProps={{
                ...register(
                  "description",
                  // {
                  //   required: locale(required_field,
                  //   max: {
                  //     value: 500,
                  //     message: locale(max_chars.replace(
                  //       "%NUM%",
                  //       "500"
                  //     ),
                  //   },
                  // }
                ),
                // maxLength: 500,
              }}
              label={locale("description")}
              error={formState?.errors?.description?.message}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export type ComponentPropsType = {
  componentData: dataStateType;
  watchedInputs: any;
  vehicleType: VehicleTypesT;
  register: UseFormRegister<any>;
  control: Control<any, any>;
  setValue: CallableFunction;
  defaultImages: { image: string; id: number }[];
  deletedImages: number[];
  setImages: CallableFunction;
  formState: FormState<any>;
  isEditing: boolean;
  setError: UseFormSetError<any>;
};
